@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.tag {
  display: flex;
  align-items: center;
  padding-left:  hevo-toolkit-variables.$spacer * 0.5;
  padding-right:  hevo-toolkit-variables.$spacer * 0.125;
  border-radius:  hevo-toolkit-variables.$border-radius-sm;
  font-size:  hevo-toolkit-variables.$font-size-caption;
  font-weight: 600;
  line-height: 16px;
  font-family:  hevo-toolkit-variables.$font-family;
  font-style: normal;
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  color:  hevo-toolkit-variables.$text-default;
  background:  hevo-toolkit-variables.$surface-bg;
  overflow: hidden;
  margin-left:  hevo-toolkit-variables.$spacer * 0.75;
  cursor: pointer;
  pointer-events: auto;

  &.withoutCloseButton {
    min-width: fit-content;
    padding:  hevo-toolkit-variables.$spacer * 0.32  hevo-toolkit-variables.$spacer * 0.5;
  }

  .closeButton {
    margin-left:  hevo-toolkit-variables.$spacer * 0.25;
  }
}
